import React from 'react';
import { HeaderActions } from './MainMenu';
import { MenuAvatar } from './MenuAvatar';
import { MenuMusic } from './MenuMusic';

export interface IMenuHeaderProps {
  headerActions: Record<HeaderActions, () => void>;
}

export const MenuHeader = (props: IMenuHeaderProps) => {
  return (
    <div className="row main-menu-header">
      <div className="col-12 col-md-4" />
      <div className="col-12 col-md-4">
        <div className="display-5 fw-bold">STACKS DEGENS</div>
      </div>

      <div className="col-12 col-md-2">
        <MenuAvatar headerActions={props.headerActions} />
      </div>
      <div className="col-12 col-md-2">
        <MenuMusic headerActions={props.headerActions}></MenuMusic>
      </div>
    </div>
  );
};
